<template>
  <span class="dialog-button" @click="onclick">{{label}}</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DialogButton',
  props: {
    label: String
  },
  methods: {
    onclick (e: Event) {
      this.$emit('click', e)
    }
  }
})
</script>

<style lang="scss">
  .dialog-button {
    width: 120px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #626557;
    border-radius: 6px;
    color: white;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
  }
</style>
